<template>
  <div>
    <p>
      <strong>
        {{ $t("components.sendemails.disclaimer") }}
      </strong>
    </p>
    <v-btn outlined class="ma-2" @click="printComponent">
      <v-icon class="ml-2" left dark>
        print
      </v-icon>
      {{ $t("components.sendemails.print_table") }}
    </v-btn>
    <div id="send-emails-table">
      <time>{{ date }}</time>
      <v-data-table dense :headers="headers" :items="recipients" />
    </div>
  </div>
</template>

<script>
import PrintService from "../services/print.service";
export default {
  props: ["recipients"],
  name: "send-emails",
  computed: {
    date() {
      return new Date().toDateString();
    },
  },
  methods: {
    printComponent() {
      PrintService.printComponent("send-emails-table");
    },
  },
  data() {
    return {
      headers: [
        { text: "First Name", value: "FirstName" },
        { text: "Last Name", value: "LastName" },
        { text: "Email", value: "Email" },
        { text: "Employers", value: "Employers" },
        { text: "Branches", value: "Branches" },
      ],
    };
  },
};
</script>

<style></style>
